import Commons from '../../../Services/Common/Common';

export const M_AIC_BASIC_Schema = {
  mapper: {
    /** 보이스 체크 리스트 조회 GetAicCallR1 */
    search1: {
      CustCd: (context) =>
        Commons.EncryptAES(context.userInfo?.custCd ?? '') || '',
    },
    /** 보호구 조회(AiCall) GetEquipR1 */
    search2: {
      UserId: (context) => context.userInfo?.userid ?? '',
      AuthCd: (context) =>
        Commons.EncryptAES(context.userInfo?.authCd ?? '') || '',
    },
    /** AI콜 음성 경로 DB저장 SaveAicCallU1 */
    save1: {
      UserId: (_, context) => context.userInfo?.userid ?? '',
      CustCd: (_, context) =>
        Commons.EncryptAES(context.userInfo?.custCd ?? '') || '',
      VoiceAddress: (row) => Commons.EncryptAES(row.voiceAddress ?? '') || '',
    },
    /** 작업 시작 SaveWorkStartU1 */
    save2: {
      AuthCd: (_, context) =>
        Commons.EncryptAES(context.userInfo?.authCd ?? '') || '',
      UserId: (_, context) => context.userInfo?.userid ?? '',
    },
  },
};
